import React, { Component } from 'react';
import LayoutHeader from '../Inc/Header';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { NavLink, withRouter } from 'react-router-dom';
import * as actions from '../../actions/index';
import './style.css';
import AlumniHelpReportIssue from './AlumniHelpReportIssue';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { history } from '../../container/History';
import { Modal , Menu, Button, Row, Col, Input, Form, Icon, message,Card, Upload, notification} from 'antd';
import { endsWith } from 'lodash';

class NeedHelpAlumni extends Component {
  constructor(props){
    super(props)
    this.state = {
      ComingSoon : false,
      ProgramSupport : false
    }
  }

  static propTypes = {
    location: PropTypes.object.isRequired
  }

  showAlumniProgramSupport = () => {
    this.setState({ProgramSupport : true})
  }

  hideAlumniProgramSupport = () => {
    this.setState({ProgramSupport : false})
  }

  renderAlumniProgramSupport = () => {
    return <Modal
    className='width-80 directory-help'
    centered
    visible={this.state.ProgramSupport}
    onOk={() => this.hideAlumniProgramSupport()}
    onCancel={() => this.hideAlumniProgramSupport()}
    footer={null}
    >
      <div>
        <iframe style={{width: '100%', height: '600px'}} src='https://d153zqp2yevlxw.cloudfront.net/Program%20Support%20team%20v1.2%20%20031522%20-TB%20%20022023%20(1).pdf' title='NST ALUMNI PORTAL SPECIALISTS' />
      </div>

    </Modal>
  }

  show_ComingSoon = () => {
    this.setState({
      ComingSoon: true
    })
    history.push('/need-help-alumni')
  }

  hide_ComingSoon = () => {
    this.setState({
      ComingSoon: false
    })
    history.push('/need-help-alumni')
  }

  componentDidMount = () => {
    this.props.actions.isadmin();
  }

  render () {
    const { location } = this.props;
    return (
      <div>
        <LayoutHeader />

        <Menu mode="horizontal" selectedKeys={[location.pathname]} defaultSelectedKeys={['/']} style={{ alignItems: "end", display: "Flex", justifyContent: "end"  }}>
          <Menu.Item key="/alumni-dashboard"> 
            <NavLink to="/alumni-dashboard">
              <button className='Need-help-action'>CLOSE <i class="fa fa-window-close" aria-hidden="true"></i></button>  
            </NavLink>
          </Menu.Item>
        </Menu>
        
        <div className='Alumni-NeedHelp-Container'>
            <div className='Alumni-NeedHelp-Greeting-Header'>Welcome to the Spark Directory Help Site</div>

            <div className='Alumni-NeedHelp-Greeting-Message'>
                This site is designed to provide the Spark user with general information about the website; 
                procedures for updating personal information; provide a resource listing of both the program 
                leadership along with regional support specialists knowledgeable about the website's functionality and content. 
            </div>

            <div className='Alumni-Needhelp-Topics-Container'>
               <div className='Alumni-NeedHelp-Topics-Greeting'>
                  Each of the following links will take you to information relevant to that subject.
               </div>

               <div className='Alumni-NeedHelp-Topics'>
                  <div className='Alumni-Report-Issue help-section'>
                    <button onClick={() => history.push('/need-help-alumni-report-issue')} className='ant-btn ant-btn-link'>Report an Issue</button>
                  </div>

                  {/* ---------------AAG-1259 Remove forms from page--------------------- */}

                  {/* <div className='NST-ALumni-Portal-Specialists help-section'>
                    <button onClick={() => history.push('/need-help-alumni-nst-portal')} className='ant-btn ant-btn-link'>NST Alumni Portal Specialists</button>
                  </div> */}

                  {/* <div className='Spark-Alumni-Program-Support help-section'>
                    <button onClick={() => this.showAlumniProgramSupport()} className='ant-btn ant-btn-link'>Spark Alumni Program Support</button>
                  </div> */}

                  <div className='Alumni-Update-Personal-Info help-section'>
                    <button onClick={() => this.show_ComingSoon()} className='ant-btn ant-btn-link'>Update Personal Information</button>
                  </div>

                  <div className='Alumni-FAQ help-section'>
                    <button onClick={() => this.show_ComingSoon()} className='ant-btn ant-btn-link'>Frequently Asked Questions</button>
                  </div>
               </div>
            </div>
        </div>

        {this.renderAlumniProgramSupport()}

        <Modal
            className='coming-soon-modal'
            style={{ width: '600px' }}
            title={false}
            footer={false}
            visible={this.state.ComingSoon}
            centered
            onCancel={() => this.hide_ComingSoon()}
        >
            <div className="center">
                <div className='Coming-Soon-Message'>
                    Coming Soon!
                </div>
                <Row type='flex' style={{ justifyContent: 'center', alignItems: 'center' }}>
                    <Col className='xs-center sm-center' xs={9} sm={9} md={7} lg={7} xl={7}>
                        <div className='step-container margin-top-20' >
                            <Button type="primary" className='close-comingsoon-btn' style={{ margin: 0, fontSize: '13px', width: "100%" }} onClick={() => {
                                this.hide_ComingSoon();
                            }} htmlType='submit'>CLOSE </Button>
                        </div>
                    </Col>
                </Row>
            </div>
        </Modal>


      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    isadmin: state.isadminreducer.isadmin,
  }
}

function mapDispatchToProps(dispatch) {
  return {
      actions: bindActionCreators(actions, dispatch)
  }
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(Form.create()(NeedHelpAlumni));


// WEBPACK FOOTER //
// ./src/components/AlumniHelp/NeedHelpAlumni.js